import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSelect,{staticClass:"from-field",attrs:{"filled":"","dense":"","background-color":"surface","items":_vm.fromEmails,"value":_vm.fromEmail,"disabled":!_vm.isSmtpEnabled,"hide-details":""},on:{"change":_vm.onFromEmailUpdate,"click":function($event){$event.stopPropagation();}},scopedSlots:_vm._u([{key:"prepend-inner",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('from'))+" ")]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }